export const SERVER_URL = 'https://support-member-api.wastecambodia.com'
// export const SERVER_URL = 'http://localhost:3000'

export const RESIDENT_SERVER_URL = 'https://resident-data-api.wastecambodia.com'
